export { default } from './LatestAppVersion';
